module.exports = __webpack_public_path__ + "img/greater_fire_elemental_small.b653d169.png";